/*
  Equijump Ltd. · <aaa-review-quote> - shows one review at random from the
  candidates rendered by blocks/aaa-review-quote.liquid (random mode). The
  server renders the first candidate visible as the no-JS fallback.

  Geo preference (data-geo="true"), using the visitor's country
  (window.Shopify.country, else the Liquid localization country):
    1. reviews whose country code matches the visitor's country
    2. otherwise, for visitors outside Ireland: reviews tagged "international"
       or from any non-Irish country; for visitors in Ireland: Irish reviews
       and untagged home-market reviews
    3. otherwise any review
*/
class ReviewQuote extends HTMLElement {
  connectedCallback() {
    const items = Array.from(this.querySelectorAll('[data-aaa-review-item]'));
    if (items.length < 2) return;

    const pool = this.dataset.geo === 'true' ? this.#geoPool(items) : items;
    const pick = pool[Math.floor(Math.random() * pool.length)];
    items.forEach((item) => {
      item.hidden = item !== pick;
    });
  }

  /** @param {HTMLElement[]} items */
  #geoPool(items) {
    const country = String((window.Shopify && window.Shopify.country) || this.dataset.visitorCountry || '').toUpperCase();
    if (!country) return items;

    const exact = items.filter((item) => item.dataset.country === country);
    if (exact.length) return exact;

    const isInternational = (item) =>
      (item.dataset.tags || '').split(',').some((tag) => tag.trim() === 'international') ||
      (item.dataset.country !== '' && item.dataset.country !== 'IE');

    const regional = country === 'IE' ? items.filter((item) => !isInternational(item)) : items.filter(isInternational);
    return regional.length ? regional : items;
  }
}

if (!customElements.get('aaa-review-quote')) customElements.define('aaa-review-quote', ReviewQuote);
